__turbopack_context__.v({
  "assetSkeleton": "SearchDropdown-module__4EA9La__assetSkeleton",
  "assetSkeletonRow": "SearchDropdown-module__4EA9La__assetSkeletonRow",
  "dropdownPanel": "SearchDropdown-module__4EA9La__dropdownPanel",
  "guidepost": "SearchDropdown-module__4EA9La__guidepost",
  "guidepostContent": "SearchDropdown-module__4EA9La__guidepostContent",
  "guidepostCta": "SearchDropdown-module__4EA9La__guidepostCta",
  "guidepostCtaGhost": "SearchDropdown-module__4EA9La__guidepostCtaGhost",
  "guidepostHeader": "SearchDropdown-module__4EA9La__guidepostHeader",
  "guidepostImage": "SearchDropdown-module__4EA9La__guidepostImage",
  "guidepostLinkItem": "SearchDropdown-module__4EA9La__guidepostLinkItem",
  "guidepostSection": "SearchDropdown-module__4EA9La__guidepostSection",
  "highlight": "SearchDropdown-module__4EA9La__highlight",
  "historyClearItem": "SearchDropdown-module__4EA9La__historyClearItem",
  "historyHeader": "SearchDropdown-module__4EA9La__historyHeader",
  "historyIcon": "SearchDropdown-module__4EA9La__historyIcon",
  "historyItem": "SearchDropdown-module__4EA9La__historyItem",
  "loading": "SearchDropdown-module__4EA9La__loading",
  "loadingApps": "SearchDropdown-module__4EA9La__loadingApps",
  "loadingResults": "SearchDropdown-module__4EA9La__loadingResults",
  "loadingSection": "SearchDropdown-module__4EA9La__loadingSection",
  "menu": "SearchDropdown-module__4EA9La__menu",
  "promptButton": "SearchDropdown-module__4EA9La__promptButton",
  "promptIcon": "SearchDropdown-module__4EA9La__promptIcon",
  "promptsContainer": "SearchDropdown-module__4EA9La__promptsContainer",
  "resultContent": "SearchDropdown-module__4EA9La__resultContent",
  "resultIcon": "SearchDropdown-module__4EA9La__resultIcon",
  "resultLink": "SearchDropdown-module__4EA9La__resultLink",
  "resultLinkVertical": "SearchDropdown-module__4EA9La__resultLinkVertical",
  "resultMeta": "SearchDropdown-module__4EA9La__resultMeta",
  "resultOwner": "SearchDropdown-module__4EA9La__resultOwner",
  "resultTextContainer": "SearchDropdown-module__4EA9La__resultTextContainer",
  "resultTitle": "SearchDropdown-module__4EA9La__resultTitle",
  "section": "SearchDropdown-module__4EA9La__section",
  "sectionHeader": "SearchDropdown-module__4EA9La__sectionHeader",
  "sectionHorizontal": "SearchDropdown-module__4EA9La__sectionHorizontal",
  "showMoreLink": "SearchDropdown-module__4EA9La__showMoreLink",
});
